import React from "react";
import { formatPriceChange } from "../../utils/priceUtils";

interface OptionValue {
  label: string;
  price_change?: number;
}

interface Option {
  label: string;
  values: OptionValue[];
}

interface ItemOptionsDisplayProps {
  options?: Option[];
  currency: string;
  countryCode: string;
  hidePrices?: boolean;
  /** Wrapper CSS class — defaults to "flex flex-col menu-item" */
  className?: string;
  /** CSS class applied to each option label */
  labelClassName?: string;
  /** CSS class applied to each option value */
  valueClassName?: string;
}

/**
 * Renders a list of item options (e.g. size, toppings) with optional
 * price-change indicators.  Used across pre-order baskets, order
 * summaries and managed-order item cards.
 */
const ItemOptionsDisplay: React.FC<ItemOptionsDisplayProps> = ({
  options,
  currency,
  countryCode,
  hidePrices = false,
  className = "gcw:flex gcw:flex-col menu-item",
  labelClassName = "options-label gcw:pt-2",
  valueClassName = "info-text option-options",
}) => {
  if (!Array.isArray(options) || options.length === 0) return null;

  return (
    <div className={className}>
      {options.map((opt) => (
        <div key={opt.label}>
          <strong className={labelClassName}>{opt.label}:</strong>
          {opt.values.map((val, index) => (
            <React.Fragment key={val.label}>
              <span className={valueClassName}>
                {val.label}
                {formatPriceChange(val.price_change, currency, countryCode, hidePrices)}
              </span>
              {index < opt.values.length - 1 && ", "}
            </React.Fragment>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ItemOptionsDisplay;
